import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { AtiraTabs } from '../../../components/AtiraTabs';
import { Drawer } from '../../../components/Drawer';
import { blogsActions } from '../../../redux/blogs/blogs.slice';
import { useAppDispatch } from '../../../redux/store';
import { FontSize } from '../../../theme/FontSize';
import { Rounded } from '../../../theme/Rounded';
import { Spacing } from '../../../theme/Spacing';
import { NotificationsAdminMessagesTab } from './NotificationsAdminMessagesTab';
import { NotificationsBlogTab } from './NotificationsBlogTab';
import { NotificationsUpdatesTab } from './NotificationsUpdatesTab';

const StyledTabs = styled(AtiraTabs)`
  padding-inline: ${Spacing.m};

  .ant-tabs-tab {
    color: ${({ theme }) => theme.main} !important;
    border-radius: ${Rounded.sm};
    transition: all 0.2s !important;
    margin-inline: 0 !important;
    border-radius: ${Rounded.md};
    border: ${({ theme }) => `1px solid ${theme.main}`};
    padding: ${Spacing.s} ${Spacing.m} !important;
    border-inline-end-color: ${({ theme }) => theme.main} !important;
  }

  .ant-tabs-tab-btn {
    transition: all 0.2s !important;
    user-select: none;
    line-height: normal !important;
    font-size: ${FontSize.s};
  }

  .ant-tabs-tab.ant-tabs-tab-active {
    border-color: ${({ theme }) => theme.main} !important;
  }

  .ant-tabs-tab-btn:active,
  .ant-tabs-tab-btn:focus:not(:focus-visible) {
    color: ${({ theme }) => theme.onMain} !important;
  }

  .ant-tabs-tab:not(.ant-tabs-tab-active):hover {
    color: ${({ theme }) => theme.onMain} !important;
    background-color: ${({ theme }) => theme.main} !important;
    border-color: ${({ theme }) => theme.main} !important;
  }

  .ant-tabs-ink-bar {
    display: none !important;
  }

  .ant-tabs-nav .ant-tabs-nav-wrap::before {
    box-shadow: none !important;
  }

  .ant-tabs-nav-list {
    gap: ${Spacing.s};
  }

  .ant-tabs-nav-list::after,
  .ant-tabs-nav .ant-tabs-nav-wrap::after {
    display: none !important;
  }

  .ant-tabs-nav {
    border: 0 !important;
  }

  .ant-tabs-tab.ant-tabs-tab-active {
    background-color: ${({ theme }) => theme.main};
    color: ${({ theme }) => theme.onMain} !important;
  }

  .ant-tabs-tab-active:hover,
  .ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${({ theme }) => theme.onMain} !important;
  }

  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: inherit !important;
  }

  //this fixes flickering issue
  .ant-tabs-nav-operations {
    display: none !important;
  }
`;

const StyledDrawer = styled(Drawer)`
  .ant-drawer-body {
    padding: 0;
  }
`;

type NotificationsDrawerProps = {
  open: boolean;
  onClose: VoidFunction;
};

export const NotificationsDrawer: React.FC<NotificationsDrawerProps> = ({
  open,
  onClose,
}) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'bell.drawer' });
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(blogsActions.getBlogs());
  }, [dispatch]);

  return (
    <StyledDrawer
      title={t('title')}
      onClose={onClose}
      open={open}
      width="32rem"
    >
      <StyledTabs
        defaultActiveKey="1"
        items={[
          {
            key: '1',
            label: t('articles_news'),
            children: <NotificationsBlogTab />,
          },
          {
            key: '2',
            label: t('products_updates'),
            children: <NotificationsUpdatesTab />,
          },
          {
            key: '3',
            label: t('admin_messages'),
            children: <NotificationsAdminMessagesTab />,
          },
        ]}
      />
    </StyledDrawer>
  );
};
